import React from "react";
import { Button, Text } from "@pushpress/shared-components";
import { useCalendarSync } from "../CalendarSyncProvider/CalendarSyncProvider";
import styles from "./UnConnectedPanel.module.scss";

interface UnConnectedPanelProps {
  userUuid: string;
  firstName: string;
}

const UnConnectedPanel = (props: UnConnectedPanelProps) => {
  const { firstName, userUuid } = props;

  const { connectGoogleAccount, isConnectingGoogle } = useCalendarSync();

  const handleConnect = async () => {
    connectGoogleAccount(userUuid);
  };

  return (
    <div className={styles.root}>
      <Text variant="body-lg" color="wolf-800" className="mb-4">
        Connecting a Google Calendar to PushPress does two things:
      </Text>
      <Text variant="heading-5" color="wolf-800" className="mb-2">
        1 - Class and appointment sync
      </Text>
      <Text variant="body-lg" color="wolf-600" className="mb-4">
        {firstName}&apos;s classes and appointments in PushPress will
        automatically be added to their Google Calendar.
      </Text>
      <Text variant="heading-5" color="wolf-800" className="mb-2">
        2 - Calendar events block availability
      </Text>
      <Text variant="body-lg" color="wolf-600" className="mb-4">
        Events on selected Google Calendars will block {firstName}&apos;s
        availability in PushPress so that they only get booked at times when
        they are available.
      </Text>
      <Button
        type="button"
        buttonType="primary"
        fullWidth
        size="large"
        text="Connect a Google Calendar"
        loading={isConnectingGoogle}
        onClick={handleConnect}
      />
    </div>
  );
};

export default UnConnectedPanel;
